/** Watch lists page copy. EN mirrors SV until proper translations are added. */
export const watchListsTranslationsSv = {
    title: 'Bevakningslista',
    watch: 'Bevaka',
    addHeading: 'Lägg till {{type}} i bevakningslista',
    searchPlaceholder: 'Sök {{type}}',
    searchAdvisor: 'Sök rådgivare',
    watchedHeading: 'Bevakade {{type}}',
    emptyMessage: 'Du bevakar inte några {{type}}. Sök efter {{type}} för att lägga till i bevakningslistan.',
    removeTooltip: 'Ta bort bevakning av {{name}}',
    addedSuccess: '{{name}} lades till i bevakningslistan.',
    alreadyExists: '{{name}} finns redan i bevakningslistan.',
    removedSuccess: '{{name}} togs bort från bevakningslistan.',
    toggle: {
        label: 'Bevakningslista',
        watches: 'Bevakningar',
    },
    groupLabels: {
        Issue: 'Emissioner',
        Warrant: 'Teckningsoptioner',
        Company: 'Bolag',
        Investor: 'Investerare',
        Convertible: 'Konvertibler',
        Advisor: 'Rådgivare',
    },
}
